export enum ApiErrorCode {
  CLIENT_SIGN_IN__CODE_INVALID = 'CLIENT_SIGN_IN__CODE_INVALID',
  CLIENT_SIGN_IN__CODE_EXPIRED = 'CLIENT_SIGN_IN__CODE_EXPIRED',
  CLIENT_SIGN_IN__EMAIL_NOT_FOUND = 'CLIENT_SIGN_IN__EMAIL_NOT_FOUND',
}
